import { createActionThunk } from 'redux-thunk-actions';
import { handleActions } from 'redux-actions';

import { Fire } from '../services'

const retrieveOrCreate = async (ref: any, payload: any) => {
  const res = await ref.get()
  if (!res.exists) {
    throw 'err'
    await ref.set(payload)
    return payload
  }
  return res.data()
}

export const autologin = createActionThunk('AUTOLOGIN', (user: any) => user)
export const saveName = createActionThunk('SAVE_REGISTER_NAME', (name: any) => name)
export const finishLogin = createActionThunk('FINISH_REGISTER', async ({ getState }) => {
  const reducer = getState().authReducer
  const userId = reducer.fireUser.uid
  const saved = reducer.savedName
  const email = reducer.fireUser.email

  try {
    const adminRef = Fire.store().collection('admins').doc(userId)
    const admin = await Fire.doc(adminRef)
    if (admin) {
      admin.admin = true
      return admin
    }
  } catch (err) {}

  const infoData = {
    id: userId,
    name: saved ? saved.name : '',
    createdAt: new Date()
  }
  const proRef = Fire.store().collection('pros').doc(userId)
  const info = await retrieveOrCreate(proRef, infoData)
  const user = {
    id: userId,
    ...info,
  }
  return user
})

export const updateUser = createActionThunk('UPDATE_USER', async (info: any, { getState }) => {
  const user = getState().authReducer.user
  await Fire.store().collection('pros').doc(user.id).update(info)
  return {
    ...user,
    ...info
  }
})

const initialState = {
  fireUser: null,
  savedName: null,

  user: null,
  updating: false,
  logging: false,
};

// Reducer
export const authReducer = handleActions(
  {
    'UPDATE_USER_STARTED': (state: any, action: any) => ({
      ...state,
      updating: true
    }),
    'UPDATE_USER_SUCCEEDED': (state: any, action: any) => ({
      ...state,
      user: action.payload,
      updating: false
    }),
    'UPDATE_USER_FAILED': (state: any, action: any) => ({
      ...state,
      updating: false
    }),

    'FINISH_REGISTER_STARTED': (state: any, action: any) => ({
      ...state,
      logging: true
    }),
    'FINISH_REGISTER_SUCCEEDED': (state: any, action: any) => ({
      ...state,
      user: action.payload,
      logging: false
    }),
    'FINISH_REGISTER_FAILED': (state: any, action: any) => ({
      ...state,
      logging: false
    }),

    'AUTOLOGIN_SUCCEEDED': (state: any, action: any) => ({
      ...state,
      fireUser: action.payload,
      user: null,
    }),

    'SAVE_REGISTER_NAME_SUCCEEDED': (state: any, action: any) => ({
      ...state,
      savedName: action.payload,
    }),
  },
  initialState
);
